export const getSearchWidgetExpAdConfigVersion = (
  variant: string,
  kvp: number = 26 // default kvp for search-widget-exp set in optimizely
) => {
  return `search-widget-${kvp}-${variant}`
}
